'use client';

import Image from 'next/image';
import { useIntl } from 'react-intl';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import { subscriptionBadgeSizeToPx } from '../SubscriptionBadge/Logo/logoBadgeSizeToPx';
import { SubscriptionBadgeBadgeProps } from '../SubscriptionBadge/Logo/types';
import peakFullDarkTextSrc from './peak-full-dark-text.svg';
import peakFullLightTextSrc from './peak-full-light-text.svg';
import peakIconCircleSrc from './peak-icon-circle.svg';
import peakIconSrc from './peak-icon.svg';

const getSvgSrc = ({ variant, textColor }: SubscriptionBadgeBadgeProps) => {
  switch (variant) {
    case 'icon':
      return peakIconSrc;
    case 'icon-circle':
      return peakIconCircleSrc;
    case 'full':
      if (textColor === 'light') {
        return peakFullLightTextSrc;
      }
      return peakFullDarkTextSrc;
    default:
      return peakFullDarkTextSrc;
  }
};

const PeakLogoBadge = ({ className, size = 'md', variant, textColor }: SubscriptionBadgeBadgeProps) => {
  const intl = useIntl();
  return (
    <Image
      {...setDenaliAttribute('SubscriptionBadge')}
      className={className}
      src={getSvgSrc({ variant, textColor })}
      height={subscriptionBadgeSizeToPx[size]}
      alt={intl.formatMessage({ defaultMessage: '{tier} badge image' }, { tier: 'Peak' })}
    />
  );
};

export default PeakLogoBadge;
